import { useEffect } from 'react';
const useCloseOnEsc = (isOpen, isCancelable, closeModal) => {
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.keyCode === 27) {
                closeModal();
            }
        };
        if (isCancelable && isOpen) {
            window.addEventListener('keydown', handleKeyDown);
        }
        return () => window.removeEventListener('keydown', handleKeyDown);
    });
};
export default useCloseOnEsc;
//# sourceMappingURL=useCloseOnEsc.js.map